import * as moment from 'moment';

import { Workflow } from './workflow.model';
import { FormSection } from '../forms/form-section.model';
import { FormField } from '../forms/form-field.model';

export function DefaultWorkflow(): Workflow {
  let workflow = new Workflow();
  workflow.id = 93;
  workflow.type = "MONORAIL";
  workflow.name = "Simple Upload";
  workflow.description = "Basic file upload";
  workflow.sections = []

  let section = new FormSection();
  section.columns = 8;

  let toField = new FormField();
  toField.id = "recipients";
  toField.type = "user_search";
  toField.label = "To";
  toField.required = true;
  toField.pattern = "^.*@.*.$";
  toField.columns = 12;

  let fileField = new FormField();
  fileField.id = "files";
  fileField.type = "file_select";
  fileField.required = true;
  fileField.columns = 12;

  let notesField = new FormField();
  notesField.id = "delivery_notes";
  notesField.type = "textarea";
  notesField.label = "Notes";
  notesField.columns = 8;

  let defaultExpiration = moment().add(10, 'days').format("YYYY-MM-DD");
  let expirationField = new FormField();
  expirationField.id = "expiration_date";
  expirationField.type = "date";
  expirationField.label = "Expiration Date";
  expirationField.required = true;
  expirationField.columns = 4;
  expirationField.min = 0;
  expirationField.max = 45;
  expirationField.defaultValue = {
    displayed: defaultExpiration,
    stored: defaultExpiration
  }

  section.rows = [
    [toField],
    [fileField], 
    [notesField, expirationField]
  ];

  workflow.sections.push(section);

  return workflow;
}


// WEBPACK FOOTER //
// ./src/app/workflows/default-workflow.ts